<template>
  <header class="product-detail-header">
    <div class="product-detail-header-cover-container">
      <product-cover :src="cover"
                     :alt="title"
                     :target-id="id"
                     :target-type="type"
                     :show-get-point="showGetPoint"
      />
      <ym-tag v-if="tag"
              class="product-detail-header-cover-container-tag"
              mark
              type="gradient-highlight"
      >
        {{ tag.text }}
      </ym-tag>
      <play-count v-if="playCount > 0"
                  class="product-detail-header-cover-container-play-count"
                  :count="playCount"
      />
      <slot></slot>
    </div>
    <div class="product-detail-header-title">{{ title }}</div>
    <product-tags v-if="tags && tags.length > 0"
                  class="product-detail-header-tags"
                  :tags="tags"
    />
    <p class="product-detail-header-summary">{{ subTitle }}</p>
    <div class="product-detail-header-bottom">
      <span v-if="teamSize > 0"
            class="product-detail-header-bottom-label-team-size"
      >
        {{ teamSize }}人成团
      </span>
      <div class="product-detail-header-bottom-info">
        <join-status v-if="joinStatus === 'member' || joinStatus === 'vipMember'"
                     :join-status="joinStatus"
        />
        <price v-else
               :price="price"
        />
        <header-action class="product-detail-header-bottom-info-action"
                       :target-type="type"
                       :target-id="id"
                       :target-title="title"
                       :gift="gift"
                       :collect="collect"
                       :hide-collect="hideCollect"
                       :modal-guide-info="modalGuideInfo"
        />
      </div>
    </div>
    <vip-inform-bar v-if="pageGuideInfo && pageGuideInfo.position === 'top'"
                    :button="pageGuideInfo.button"
                    :tip="pageGuideInfo.tip"
                    :url="pageGuideInfo.url"
                    :icon="pageGuideInfo.icon"
                    :background="pageGuideInfo.background"
                    v-ym-report:MARKETING_VIP_AD_PRODUCT_DETAIL_CLICK=""
    />
  </header>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';
  import JoinStatus from '@/pages/Audio/components/AudioJoinStatusBlock';
  import Price from '@/components/Price/ProductDetailPrimaryPrice';
  import ProductCover from '@/components/ProductDetailHeaderCover';
  import PlayCount from '@/components/PlayCount';
  import ProductTags from '@/components/ProductDetailTags';
  import HeaderAction from '@/components/ProductDetail/HeaderAction';
  import VipInformBar from '@/pages/Vip/components/ProductDetailVipInformBar';
  import validator from '@/utils/validator';

  export default {
    name: 'ComboDetailHeader',
    components: {
      'ym-tag': Tag,
      Price,
      JoinStatus,
      ProductCover,
      PlayCount,
      ProductTags,
      HeaderAction,
      VipInformBar,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      cover: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      subTitle: {
        type: String,
        required: true,
      },
      tag: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      tags: {
        type: Array,
        default() {
          return [];
        },
      },
      showGetPoint: Boolean,
      teamSize: {
        type: Number,
        default: 0,
      },
      playCount: {
        type: Number,
        default: 0,
      },
      joinStatus: {
        type: String,
        default: '',
      },
      price: {
        type: Object,
        required: true,
      },
      gift: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      collect: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      hideCollect: {
        type: Boolean,
      },
      modalGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      pageGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-header {
    box-sizing: border-box;
    width: 100%;
    background: @color-white;
    border-bottom: @size-extra-small solid @background-color-base;

    &-cover-container {
      position: relative;
      &-tag {
        position: absolute;
        left: 0;
        top: @size-base;
      }
      &-play-count {
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    &-title {
      box-sizing: border-box;
      width: 100%;
      margin: @size-base 0 @size-extra-small 0;
      padding: 0 @size-base;
      color: @color-black-dark;
      font-size: @font-size-extra-extra-large;
      line-height: 1.5;
      font-weight: @font-weight-bold;
    }
    &-tags {
      box-sizing: border-box;
      width: 100%;
      margin-bottom: @size-small;
      padding-left: @size-base;
    }
    &-summary {
      margin: 0;
      padding: 0 @size-base;
      color: @color-text-light;
      font-size: @font-size-base;
      line-height: 1.2;
    }
    &-bottom {
      box-sizing: border-box;
      margin-top: @size-medium;
      padding: 0 @size-base @size-base @size-base;

      &-desc {
        display: flex;
        align-items: center;
        color: @color-text-lighter;
        font-size: @font-size-small;
      }
      &-label-team-size {
        margin-bottom: @size-extra-small;
        font-size: @font-size-extra-small;
        color: @group-buy-team-size-color;
        background: @group-buy-team-size-background;
        border-radius: @border-radius-medium;
      }

      &-info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-action {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .combo-header {
    background: @color-white;
    margin-bottom: @size-small;
    padding: 0 @size-base @size-base;
  }

  .combo-cover-container {
    margin: 0 -@size-base;
    position: relative;
  }

  .combo-title-desc {
    color: @color-text-light;
    margin-top: @size-small;
    margin-bottom: @size-extra-small;
  }

  .combo-summary {
    margin: @size-small 0 @size-base;
    font-size: @font-size-small;
    color: @color-text-light;
  }

  .combo-desc {
    display: flex;
    align-items: center;
    color: @color-text-lighter;
    font-size: @font-size-small;
  }

  .product-title {
    margin: 0 0 @size-extra-small;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
  }

  .label-team-size {
    margin-bottom: @size-extra-small;
    font-size: @font-size-extra-small;
    color: @group-buy-team-size-color;
    background: @group-buy-team-size-background;
    border-radius: @border-radius-medium;
  }

  .combo-play-count {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    .icon {
      margin-right: @size-extra-small / 2;
    }
  }

</style>
